import React from "react";
import { Input } from "antd";

const UIPassword = ({
  placeholder = "",
  value = "",
  size = "middle",
  onchange = { onchange },
}) => {
  return (
    <Input.Password
      size={size}
      placeholder={placeholder}
      value={value}
      onChange={(e) => {
        onchange(e.target.value);
      }}
    />
  );
};

export default UIPassword;
